import { FormReviewData } from "@/types";
import { formatFieldName, formatArrayValue } from "@/utils/formatters";

interface TravelPlansSectionProps {
  formData: FormReviewData;
}

export function TravelPlansSection({ formData }: TravelPlansSectionProps) {
  const travelPlans = formData?.formData?.travel_plans;
  if (!travelPlans || Object.keys(travelPlans).length === 0) return null;

  return (
    <div className="info-card travel-plans">
      <h3>Travel Plans & Activities</h3>
      <div
        className="travel-plans-grid"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        {Object.entries(travelPlans).map(([key, value], index) => (
          <div
            key={key}
            className={`travel-plan-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 items-start ${index < Object.keys(travelPlans).length - 1 ? "pb-3 border-b border-gray-200" : ""}`}
          >
            <label style={{ fontWeight: "700", color: "#374151" }}>
              {formatFieldName(key)}:
            </label>
            <span
              style={{
                color: "#1f2937",
                fontWeight: "500",
              }}
            >
              {Array.isArray(value) ? formatArrayValue(value) : String(value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
